/** TanStack Query key factory for the activity/notifications feed. */
export const activityKeys = {
  all: ["activity"] as const,
  feed: (limit: number, offset: number) => [...activityKeys.all, "feed", limit, offset] as const,
};
